import { LEAVE_PAGE_TRUE } from '../types/conversationPreview';

export const commonReducer = (state = {}, action) => {
  switch (action.type) {
    case LEAVE_PAGE_TRUE: {
      return {
        ...state,
        leavePage: true,
      };
    }
    default:
      return state;
  }
};
